import React, { useState } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AddRowTable from '../../Components/Table/AddRowTable';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';
import { SeeAttachment } from '../../Components/SeeAttachment';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Checkbox,
    Upload,
    Form,
    Select,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    AutoComplete,
    Modal,
    Space,
    Switch,
    Table,
} from 'antd'
import { 
    ExclamationCircleFilled, 
    InboxOutlined, 
    DeleteOutlined,
    ProductOutlined, 
} from '@ant-design/icons';
import { 
    useNavigate, 
    useParams 
} from 'react-router-dom';
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatDate } from '../../Utils/Common';

const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

const AddEditTenants = () => {
    const [addTenantForm] = Form.useForm();
    const { id, type } = useParams();
    const navigate = useNavigate()
    const currentDate = new Date().toISOString().split('T')[0];
    const [isManage, setIsManage] = useState(false);
    const [manageType, setManageType] = useState(true);
    const [startContractData, setStartContractDate] = useState({
        start_date: currentDate
    })
    const [startParkingContractData, setParkingStartContractDate] = useState({
        start_date: currentDate
    })
    const [isDisabled, setIsDisabled] = useState(true);
    const [isCusa, setIsCusa] = useState(false);
    const [isAlfresco, setIsAlfresco] = useState(false);
    const [propertyId, setPropertyId] = useState('')
    const [leaseTerm, setLeaseTerm] = useState({
        parking: '',
        unit:'',
    })
    const [leaseType, setLeaseType] = useState({
        parking: 'year',
        unit:'year',
    })
    const [authorizedSignatories, setAuthorizedSignatories] = useState([{}]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [newAttachment, setNewAttachment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [authorizedRepresentative, setAuthorizedRepresentative] = useState([{}]);
    const [propertyData, setPropertyData] = useState([])
    const [propertyParkingData, setPropertyParkingData] = useState([])
    const [rentalData, setRentalData] = useState([])
    const [tenantData, setTenantData] = useState([])
    const [options, setOptions] = useState([])
    const [parkingRow, setParkingRow] = useState([
        {
            property_id: '',
            parking_unit_ids: '',
            parking_rental_rates: '',
            management_fee: '',
            agent_fee: '',
            is_managed: false,
            manage_type: false,
        }
    ]);

    const [renterId, setRenterId] = useState('')
    const [withParking, setWithParking] = useState(false)
    const [contractDate, setContractDate] = useState([])
    const { callPost, data, loading } = usePostRequest(()=>{
        addTenantForm.resetFields();
    });
    
    const values = Form.useWatch([], addTenantForm);
    React.useEffect(() => {
        addTenantForm.validateFields({
        validateOnly: true,
        }).then(() => {
        setIsDisabled(false);
        },
        () => {
        setIsDisabled(true);
        },
        );
    }, [values, addTenantForm]);

    React.useEffect(() => {
        if (data && type === 'add') {
            navigate('/tenant/rate/' + data.tenant_id);
        } else if(data && type === 'edit') {
            navigate('/tenant');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

     React.useEffect(() => {
        if(id){
            fetchTenantData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    React.useEffect(() => {
        fetchRentalData();
        fetchPropertyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    React.useEffect(() => {
        fetchPropertyParkingData();
        fetchTenantDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    React.useEffect(() => {
        handleSaveValidation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [withParking]);

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    const columns2 = [
        {
            title: 'Date Added',
            dataIndex: 'added_on',
            key: 'added_on',
            width: '30%',
            render: (amount) => formatDate(amount),
        },
        {
            title: 'Attachments',
            dataIndex: 'link',
            key: 'link',
        },
    ]; 

    const handleSaveValidation = () => {
        if(type === 'add'){
            var isValid = false;
            if (withParking) {
                isValid = isDisabled || parkingRow.some(row => 
                    !row.property_id || 
                    !row.parking_unit_ids || 
                    !row.parking_rental_rates
                );
            } else {
                isValid = isDisabled;
            }
            return isValid;
        }
    };
    
    const handleAddRow = () => {
        const newRow = {
            property_id: '',
            parking_unit_ids: '',
            parking_rental_rates: '',
            management_fee: '',
            agent_fee: '',
            is_managed: false,
            manage_type: false,
        };
        setParkingRow(prev => [...prev, newRow]);
    };
    
    const handleDeleteRow = (rowId) => {
        const newData = [...parkingRow];
        newData.splice(rowId, 1); 
        setParkingRow(() => newData)
    };

    const handleProperty = (e) => {
        setPropertyId(e)
    };

    const handleSaveContract = () => {
        if(type === 'add'){
            handleAddTenant();
        } else {
            handleEditTenant();
        }
    };

    const fetchOptions = (value) => {
        const data = tenantData
        return data
            .filter(item => item.trade_name.toLowerCase().includes(value.toLowerCase()))
            .map(item => ({ value: item.trade_name }));
    };

    const handleonSearch = (value) => {
        const fetchedOptions = fetchOptions(value);
        setOptions(fetchedOptions);
    };

    const handleOnSelect = (value) => {
        const item = tenantData.find(option => option.trade_name === value);
        setRenterId(item.renter_id);
    };

    const normFile = (e) => {
        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
    };

    const validateContactNumber = (_, value) => {
        if (!value) {
          return Promise.resolve();
        }
    
        const isNumber = /^\d+$/.test(value);
        if (!isNumber) {
          return Promise.reject('Invalid Contact Number');
        }
        return Promise.resolve();
    };

    const fileUrlFormat = (files) => {
        if(files){
          return files?.map(file => ({
            uid: file.id,
            id: file.id,
            name: file.file_name,
            status: "done",
            url: file.file_url,
            fileType: file.file_type
          }));
        }
    };

    const handleRentalUnit = (rental_id) => {
        const rent = rentalData.filter((item) => item.id === rental_id);
        if(rent[0]?.pricing_type === "unit"){
            addTenantForm.setFieldsValue({
                space_rental_rate: rent[0].unit_price,
                property: rent[0].property_id
            });
        } else {
            addTenantForm.setFieldsValue({
                space_rental_rate: '',
                property: rent[0].property_id
            });
        }
        setIsAlfresco( rent[0].cusa_area !== "0.00" ? true : false )
       
        setIsCusa( rent[0].alfresco_area !== "0.00" ? true : false )
    }

    const handleParkingUnit = (e, recordKey, fieldName, parkingLists) => {
        const updatedDataSource = parkingRow.map((item, index) => {
            if (index === recordKey) {
                if(fieldName === 'property_id'){
                    const parking_data = propertyParkingData.filter(data => data.id === e);
                    return { ...item, parking_list: parking_data[0].parking_units, [fieldName]: e, parking_unit_ids: '' };
                } else if(fieldName === 'parking_unit_ids'){
                    const parking = parkingLists.filter(data => data.id === e);
                    return { ...item, [fieldName]: e, parking_rental_rates: parking[0].unit_price};
                } else {
                    return { ...item, [fieldName]: e };
                }
            }
            return item;
        });
        setParkingRow(updatedDataSource);
    };

    async function fetchTenantDropdown() {
        const response = await UseGetRequest("tenants/get_active_renter",);
        if (response?.data) {
          setTenantData(response?.data?.data);
        } else {
          setTenantData([])
        }
    };

    async function fetchParkingUnit() {
        try {
            const response = await UseGetRequest("parking_units/get", { property_id: '' });
            return response.data.data;
        } catch (error) {
            return [];
        }
    };

    async function fetchPropertyData() {
        const response = await UseGetRequest("properties/get_for_contract", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }
    };

    async function fetchPropertyParkingData() {
        const response = await UseGetRequest("properties/get_for_parking_contract", {property_id: ''});
        if (response?.data) {
          setPropertyParkingData(response?.data?.data);
        } else {
          setPropertyParkingData([])
        }
    };

    async function fetchRentalData() {
        const response = await UseGetRequest("rental_units/get", {property_id: propertyId, status: 'vacant'});
        if (response?.data) {
          setRentalData(response?.data?.data);
        } else {
          setRentalData([])
        }
    };

    async function fetchTenantData() {
        setIsLoading(true)
        const response = await UseGetRequest("tenants/get", {tenant_id: id});
        if (response?.data) {
            const tenant_data = response?.data?.data[0]
            setRenterId(tenant_data?.renter_id)
            setAuthorizedSignatories(tenant_data?.signatories);    
            setAuthorizedRepresentative(tenant_data?.representatives);   
            let attachment = tenant_data?.attachments?.map((file) => ({
                ...file,
                link: (
                    <SeeAttachment
                    attachments={[
                        { file_url: file.file_url, file_name: file.file_name },
                    ]}
                    />
                ),
                })) 

            const parking_list = await fetchParkingUnit();

            let parking_details = tenant_data?.tenant_parkings?.map((file) => ({
                ...file,
                property_id: file.property_id,
                parking_unit_ids: file.parking_unit_id,
                parking_rental_rates: file.parking_rental_rate,
                parking_list: parking_list || [],
                is_managed: file.is_managed === '1' ? true : false,
                manage_type: file.is_managed === 'percentage' ? true : false,
            })) 

            setParkingRow(parking_details)
            setAttachmentsData(fileUrlFormat(tenant_data?.attachments))
            setNewAttachment(attachment)
            addTenantForm.setFieldsValue({
                alfresco_rental_rate: tenant_data.alfresco_rental_rate,
                require_or: tenant_data.require_or === "1" ? true : false,
                business_address: tenant_data.business_address,
                business_name: tenant_data.business_name,
                business_nature: tenant_data.business_nature,
                contact_no: tenant_data.contact_no,
                contract_date: [
                    tenant_data.contract_sign_date ? dayjs(tenant_data.contract_sign_date, 'YYYY/MM/DD') : undefined,
                    tenant_data.contract_end_date ? dayjs(tenant_data.contract_end_date, 'YYYY/MM/DD') : undefined
                ],
                cusa_rental_rate: tenant_data.cusa_rental_rate,
                lease_term: tenant_data.lease_term,
                lease_type: tenant_data.lease_type,
                property: tenant_data.property_name,
                remarks: tenant_data.remarks,
                rental_unit_id: tenant_data.rental_unit_id,
                renter_email: tenant_data.renter_email,
                space_rental_rate: tenant_data.space_rental_rate,
                start_date: tenant_data.start_date ? dayjs(tenant_data.start_date, 'YYYY/MM/DD') : undefined,
                tin: tenant_data.tin,
                with_parking: tenant_data.with_parking === "1",
                trade_name: tenant_data.trade_name,
                agent_fee: tenant_data.agent_fee,
                management_fee: tenant_data.management_fee,
            });
            setContractDate([
                tenant_data.contract_sign_date ? dayjs(tenant_data.contract_sign_date, 'YYYY/MM/DD') : undefined,
                tenant_data.contract_end_date ? dayjs(tenant_data.contract_end_date, 'YYYY/MM/DD') : undefined
            ])
            setIsManage(tenant_data.is_managed === '1' ? true : false)
            setManageType(tenant_data.manage_type)
            setLeaseTerm(tenant_data.lease_term)
            setLeaseType(tenant_data.lease_type)
            setStartContractDate(tenant_data.contract_sign_date)
            setWithParking(tenant_data.with_parking === "1")
        }
        setIsLoading(false)
    }
   
    const handleAddTenant = () => {
        addTenantForm.validateFields().then(values => {
            const resetData = {
                alfresco_rental_rate: values.alfresco_rental_rate || '',
                require_or: values.require_or ? '1' : '0',
                with_parking: values.with_parking ? '1' : '0',
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                contract_sign_date: values.contract_date[0].format("YYYY-MM-DD") || '',
                contract_end_date: values.contract_date[1].format("YYYY-MM-DD") || '',
                cusa_rental_rate: values.cusa_rental_rate || '',
                lease_type: values.lease_type || '',
                lease_term: values.lease_term || '',
                property: values.property || '',
                remarks: values.remarks || '',
                rental_unit_id: values.rental_unit_id || '',
                renter_email: values.renter_email || '',
                space_rental_rate: values.space_rental_rate || '',
                start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
                agent_fee: values.agent_fee || '',
                is_managed: isManage
            };

            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });

            if (renterId) {
                resetData.renter_id = renterId;
            }           

            if (isManage) {
                resetData.management_fee = values.management_fee || '';
                resetData.manage_type = manageType ? "percentage" : "fixed";
            }            

            resetData.parking_unit_ids = parkingRow.map((data)=> data.parking_unit_ids)
            resetData.parking_rental_rates = parkingRow.map((data)=> data.parking_rental_rates)
            resetData.parking_is_managed = parkingRow.map((data)=> data.is_managed)
            resetData.parking_management_fees = parkingRow.map((data)=> data.is_managed ? data.management_fee : '')
            resetData.parking_agent_fees = parkingRow.map((data)=> data.agent_fee)
            resetData.parking_manage_types = parkingRow.map((data)=> data.is_managed ? data.manage_type ? 'percentage' : 'fixed' : '')

            resetData.signatory_name = authorizedSignatories.map((item)=>item.signatory_name || "")
            resetData.signatory_position = authorizedSignatories.map((item)=>item.signatory_position || "")
            resetData.representative_name = authorizedRepresentative.map((item)=>item.representative_name || "")
            resetData.representative_position = authorizedRepresentative.map((item)=>item.representative_position || "")
            resetData.representative_email = authorizedRepresentative.map((item)=>item.representative_email || "")
            resetData.representative_contact_no = authorizedRepresentative.map((item)=>item.representative_contact_no || "")

            var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "tenants/create", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const handleEditTenant = () => {
        addTenantForm.validateFields().then(values => {
            const resetData = {
                tenant_id: id,
                alfresco_rental_rate: values.alfresco_rental_rate || '',
                require_or: values.require_or ? '1' : '0',
                with_parking: values.with_parking ? '1' : '0',
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                contract_sign_date: values.contract_date[0].format("YYYY-MM-DD") || '',
                contract_end_date: values.contract_date[1].format("YYYY-MM-DD") || '',
                cusa_rental_rate: values.cusa_rental_rate || '',
                lease_type: values.lease_type || '',
                lease_term: values.lease_term || '',
                property: values.property || '',
                remarks: values.remarks || '',
                rental_unit_id: values.rental_unit_id || '',
                renter_email: values.renter_email || '',
                space_rental_rate: values.space_rental_rate || '',
                start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
                agent_fee: values.agent_fee || '',
                is_managed: isManage
            };

            const file = attachmentsData
            .filter(data => data.originFileObj)
            .map(data => data.originFileObj);
        
            const attch_ids = attachmentsData
            .filter(data => data.id)
            .map(data => data.id);

            if (renterId) {
                resetData.renter_id = renterId;
            }           

            if (isManage) {
                resetData.management_fee = values.management_fee || '';
                resetData.manage_type = manageType ? "percentage" : "fixed";
            }            

            resetData.parking_unit_ids = parkingRow.map((data)=> data.parking_unit_ids)
            resetData.parking_rental_rates = parkingRow.map((data)=> data.parking_rental_rates)
            resetData.parking_is_managed = parkingRow.map((data)=> data.is_managed)
            resetData.parking_management_fees = parkingRow.map((data)=> data.is_managed ? data.management_fee : '')
            resetData.parking_agent_fees = parkingRow.map((data)=> data.agent_fee)
            resetData.parking_manage_types = parkingRow.map((data)=> data.is_managed ? data.manage_type ? 'percentage' : 'fixed' : '')

            resetData.signatory_name = authorizedSignatories.map((item)=>item.signatory_name || "")
            resetData.signatory_position = authorizedSignatories.map((item)=>item.signatory_position || "")
            resetData.representative_name = authorizedRepresentative.map((item)=>item.representative_name || "")
            resetData.representative_position = authorizedRepresentative.map((item)=>item.representative_position || "")
            resetData.representative_email = authorizedRepresentative.map((item)=>item.representative_email || "")
            resetData.representative_contact_no = authorizedRepresentative.map((item)=>item.representative_contact_no || "")

            var finalValues = Object.entries({...resetData, attachments: file, attachment_ids: attch_ids }).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "tenants/update", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const onLeaseType = (value, type) => {
        if(type === "parking"){
            if (value) {
                setLeaseType({
                    parking: value
                })
                if(value === "month"){
                    addTenantForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                    ])
                } else {
                    addTenantForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                    ])
                }
            }
        } else {
            if (value) {
                setLeaseType({
                    unit: value
                })
                if(value === "month"){
                    addTenantForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                    ])
                } else {
                    addTenantForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                    ])
                }
            }
        }
    }

    const onLeaseChange = (value, type) => {
        if(type === 'parking') {
            if (value) {
                setLeaseTerm({
                    parking: value
                });
                if(leaseType.parking === "month"){
                    addTenantForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                    ])
                } else {
                    addTenantForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                    ])
                }
            }
        } else {
            if (value) {
                setLeaseTerm({
                    unit: value
                });                
                if(leaseType.unit === "month"){
                    addTenantForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                    ])
                } else {
                    addTenantForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                    ])
                }
            }
        }
    }

    const handleRangeChange = (dates, type) => {
        if(type === 'parking'){
            if (dates && dates.length > 0) {
                addTenantForm.setFieldsValue({
                    parking_contract_date: [
                        dayjs(dates[0], 'YYYY/MM/DD'),
                        dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, leaseType.parking)
                    ]
                });
                setParkingStartContractDate(() => ({
                    start_date: dates[0]
                }))
                setContractDate([
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, leaseType.parking)
                ])
            }
        } else {
            if (dates && dates.length > 0) {
                addTenantForm.setFieldsValue({
                    contract_date: [
                        dayjs(dates[0], 'YYYY/MM/DD'),
                        dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, leaseType.unit)
                    ]
                });
                setStartContractDate(() => ({
                    start_date: dates[0]
                }))
                setContractDate([
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, leaseType.unit)
                ])
            }
        }
    };

    const showSaveConfirm = () => {
        confirm({
          title: 'Please review Lease Term and Contract Date',
          icon: <ExclamationCircleFilled style={{ color: 'yellow' }}/>,
          content: (
            <div>
              <div>Lease Term: {leaseTerm?.unit} {leaseType?.unit}</div>
              <div>Contract Date: {contractDate && formatDate(contractDate[0]?.format("YYYY-MM-DD"))} - {formatDate(contractDate[1]?.format("YYYY-MM-DD"))}</div>
            </div>
          ),
          okText: 'Yes',
          cancelText: 'No',
          className: 'custom-modal',
          confirmLoading: loading,
          onOk() {
            handleSaveContract()
          },
        });
    };

    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        {type === 'add' ? 'ADD RENTER' : 'EDIT RENTER'}
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-3'>
                        <Form form={addTenantForm} initialValues={{ lease_type: leaseType.unit, parking_lease_type: leaseType.parking }} layout="vertical" scrollToFirstError={true}>
                            <Divider className='divider-text'>Renter Information</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Name"
                                        name="trade_name"
                                        rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <AutoComplete
                                            options={options}
                                            disabled={type === 'edit'}
                                            onSearch={handleonSearch}
                                            onSelect={handleOnSelect}
                                            placeholder="Type to search"
                                        >
                                            <Input/>
                                        </AutoComplete>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Name"
                                        name="business_name"
                                        // rules={[{ required: true, message: 'Please enter your confirm Business Name!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Address"
                                        name="business_address"
                                        rules={[{ required: true, message: 'Please enter your confirm Business Address!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="TIN Number"
                                        name="tin"
                                        // rules={[{ required: true, message: 'Please enter your Tin!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Renter Email"
                                        name="renter_email"
                                        rules={[
                                            { required: true, message: 'Please enter your email address!' },
                                            { type: 'email', message: 'Please enter a valid email address!' }
                                        ]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Contact Number"
                                        name="contact_no"
                                        rules={
                                            [
                                                { 
                                                    required: true, message: 'Please enter your Contact Number!' 
                                                },
                                                {
                                                    validator: validateContactNumber
                                                },
                                            ]
                                        }
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={12}>
                                    <Item
                                        label="Nature of Renter"
                                        name="business_nature"
                                        // rules={[{ required: true, message: 'Please enter your confirm Contact Person!' }]}
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text mt-5'>Unit Detail</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={7}>
                                    <Item
                                        label="Property/Building"
                                        name="property"
                                        rules={[{ required: true, message: 'Please select your Property/Building' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a property" 
                                            onChange={(e) => handleProperty(e)}
                                            showSearch
                                            disabled={type === 'edit'}
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {propertyData?.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={7}>
                                    <Item
                                        label="Unit Number"
                                        name="rental_unit_id"
                                        rules={[{ required: true, message: 'Please select your Unit Number' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a Rental Unit" 
                                            onChange={(e) => handleRentalUnit(e)}
                                            showSearch
                                            disabled={type === 'edit'}
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {rentalData?.map((option) => (
                                                <Option key={option.id} value={option.id}>{option.unit_owner}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={4} className='center pt-4'>
                                    <Item name="require_or" valuePropName="checked">
                                        <Checkbox>OR Required upon Payment</Checkbox>
                                    </Item>
                                </Col>
                                <Col span={3} className='center pt-4'>
                                    <Item name="with_parking" valuePropName="checked" value={withParking} onChange={(e) => setWithParking(e.target.checked)}>
                                        <Checkbox
                                            disabled={type === 'edit'}
                                        >
                                            With Parking
                                        </Checkbox>
                                    </Item>
                                </Col>
                                <Col span={3} className='center'>
                                    <Switch
                                        checked={isManage}
                                        checkedChildren="Manage"
                                        unCheckedChildren="Not Manage"
                                        size='medium'
                                        disabled={type === 'edit'}
                                        // className='mt-2'
                                        style={{ backgroundColor: isManage ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                        onChange={() => {
                                            setIsManage(!isManage);
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Lease Type"
                                        name="lease_type"
                                        rules={[{ required: true, message: 'Please select your Lease Type' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a Lease Type" 
                                            disabled={type === 'edit'}
                                            onChange={(e) => onLeaseType(e, 'unit')}
                                            defaultValue={leaseType.unit} 
                                        >
                                            <Option key='month' value='month'>Monthly</Option>
                                            <Option key='year' value='year'>Yearly</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Lease Term"
                                        name="lease_term"
                                        rules={[{ required: true, message: 'Please enter your Lease Term!' }]}
                                    >
                                        <InputNumber 
                                            min={0}
                                            disabled={type === 'edit'}
                                            style={{width:'100%'}}
                                            onChange={(e) => onLeaseChange(e, 'unit')}
                                        />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item 
                                        name="contract_date"  
                                        label="Contract Date"
                                        rules={[{ required: true, message: 'Please enter your Signed Contract Date!' }]}
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            disabled={leaseTerm.unit ? [false, true] : true}
                                            onChange={(e) => handleRangeChange(e, 'unit')}
                                            allowClear={false}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Move In Date"
                                        name="start_date"
                                        // rules={[{ required: true, message: 'Please enter your Commencement of Lease!' }]}
                                    >
                                        <DatePicker 
                                            disabled={type === 'edit'}
                                            style={{width:'100%'}} 
                                            format="YYYY-MM-DD"
                                        />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Rental Rate"
                                        name="space_rental_rate"
                                        rules={[{ required: true, message: 'Please enter your Rental Rate!' }]}
                                    >
                                        <InputNumber 
                                            disabled={type === 'edit'}
                                            style={{width:'100%'}} 
                                        />
                                    </Item>
                                </Col>
                                {
                                    isCusa && (
                                        <Col span={4}>
                                            <Item
                                                label="Cusa Rental Rate"
                                                name="cusa_rental_rate"
                                            >
                                                <InputNumber 
                                                    disabled={type === 'edit'}
                                                    style={{width:'100%'}} 
                                                />
                                            </Item>
                                        </Col>
                                    )
                                }
                                {
                                    isAlfresco && (
                                        <Col span={4}>
                                            <Item
                                                label="Alfresco Rental Rate"
                                                name="alfresco_rental_rate"
                                            >
                                                <InputNumber 
                                                    disabled={type === 'edit'}
                                                    style={{width:'100%'}} 
                                                />
                                            </Item>
                                        </Col>
                                    )
                                }
                            </Row>
                            
                            {
                                isManage ?
                                (
                                    <Row  className='responsive-inline responsive-width'>
                                        <Divider className='divider-text'>Rental Unit Fees</Divider>
                                        <Col span={8} className='p-2'>
                                            <Space>
                                            <Item
                                                label="Management Fee"
                                                name="management_fee"
                                            >
                                                <InputNumber
                                                    style={{width:'100%'}}
                                                    disabled={type === 'edit'}
                                                />
                                            </Item>
                                            <Switch
                                                checked={manageType}
                                                checkedChildren="Percentage"
                                                unCheckedChildren="Fixed Price"
                                                size='medium'
                                                // className='mt-2'
                                                style={{ backgroundColor: manageType ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                onChange={() => {
                                                    setManageType(!manageType);
                                                }}
                                            />
                                            </Space>
                                        </Col>
                                        <Col span={8} className='p-2'>
                                            <Item
                                                label="Agent Fee"
                                                name="agent_fee"
                                            >
                                                <InputNumber
                                                    style={{width:'100%'}}
                                                    disabled={type === 'edit'}
                                                />
                                            </Item>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row  className='responsive-inline responsive-width'>
                                        <Divider className='divider-text'>Rental Unit Fee</Divider>
                                        <Col span={8} className='p-2'>
                                            <Item
                                                label="Agent Fee"
                                                name="agent_fee"
                                            >
                                                <InputNumber
                                                    style={{width:'100%'}}
                                                    disabled={type === 'edit'}
                                                />
                                            </Item>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                withParking && (
                                    <>
                                        <Divider className='divider-text mt-5'>Parking Detail</Divider>
                                        {
                                                parkingRow.map((data, index) => (
                                                    <div
                                                        className='parking-list'
                                                    >
                                                        <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                                            <Col span={7}>
                                                                <div>
                                                                    Property/Building
                                                                </div>
                                                                <Select 
                                                                    style={{width:'100%'}}
                                                                    disabled={type === 'edit'}
                                                                    placeholder="Select a property" 
                                                                    value={data.property_id}
                                                                    onChange={(e) => handleParkingUnit(e, index, 'property_id')}
                                                                    showSearch
                                                                    filterOption={(input, option) =>
                                                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                    }
                                                                >
                                                                    {propertyParkingData?.map((option) => (
                                                                        <Option key={option.id} value={option.id}>{option.name}</Option>
                                                                    ))}
                                                                </Select>
                                                            </Col>
                                                            <Col span={7}>
                                                                <div>
                                                                    Parking Unit
                                                                </div>
                                                                <Select 
                                                                    style={{width:'100%'}}
                                                                    disabled={type === 'edit'}
                                                                    value={data.parking_unit_ids}
                                                                    placeholder="Select a Parking Unit" 
                                                                    onChange={(e) => handleParkingUnit(e, index, 'parking_unit_ids', data.parking_list)}
                                                                    showSearch
                                                                    filterOption={(input, option) =>
                                                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                    }
                                                                >
                                                                    {data.parking_list?.map((option) => (
                                                                        <Option key={option.id} value={option.id}>{option.name}</Option>
                                                                    ))}
                                                                </Select>
                                                            </Col>
                                                            <Col span={4}>
                                                                <div>
                                                                    Parking Rate
                                                                </div>
                                                                <InputNumber 
                                                                    onChange={(e) => handleParkingUnit(e, index, 'parking_rental_rates')}
                                                                    value={data.parking_rental_rates}
                                                                    style={{width:'100%'}} 
                                                                    disabled={type === 'edit'}
                                                                />
                                                            </Col>
                                                            <Col span={4} className='center'>
                                                                <Switch
                                                                    checked={data.is_managed}
                                                                    checkedChildren="Manage"
                                                                    unCheckedChildren="Not Manage"
                                                                    size='medium'
                                                                    disabled={type === 'edit'}
                                                                    style={{ backgroundColor: data.is_managed ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                                    onChange={(e) => handleParkingUnit(e, index, 'is_managed')}
                                                                />
                                                            </Col>
                                                            <Col span={1} align='center'>
                                                                {
                                                                    (type === 'add' && parkingRow.length > 1) && (
                                                                        <Button
                                                                            icon={<DeleteOutlined />}
                                                                            onClick={() => handleDeleteRow(index)}
                                                                            type="link"
                                                                            size='large'
                                                                            danger
                                                                            disabled={type === 'edit'}
                                                                        />
                                                                    )
                                                                }
                                                            </Col>
                                                        </Row>
                                                        {
                                                            data.is_managed ?
                                                            (
                                                                <Row  className='responsive-inline responsive-width mt-2 mb-4'>
                                                                    <Col span={7}>
                                                                        <div>
                                                                            Management Fee
                                                                        </div>
                                                                        <Space>
                                                                            <InputNumber
                                                                                onChange={(e) => handleParkingUnit(e, index, 'management_fee')}
                                                                                value={data.management_fee}
                                                                                style={{width:'100%'}} 
                                                                                disabled={type === 'edit'}
                                                                            />
                                                                            <Switch
                                                                                checked={data.manage_type}
                                                                                checkedChildren="Percentage"
                                                                                unCheckedChildren="Fixed Price"
                                                                                size='medium'
                                                                                disabled={type === 'edit'}
                                                                                style={{ backgroundColor: data.manage_type ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                                                onChange={(e) => handleParkingUnit(e, index, 'manage_type')}
                                                                            />
                                                                        </Space>
                                                                    </Col>
                                                                    <Col span={7}>
                                                                        <div>
                                                                            Agent Fee
                                                                        </div>
                                                                        <InputNumber
                                                                            onChange={(e) => handleParkingUnit(e, index, 'agent_fee')}
                                                                            value={data.agent_fee}
                                                                            style={{width:'100%'}} 
                                                                            disabled={type === 'edit'}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            ) : (
                                                                <Row  className='responsive-inline responsive-width mt-2 mb-4'>
                                                                    <Col span={7}>
                                                                        <Space>
                                                                            Agent Fee
                                                                        </Space>
                                                                        <InputNumber
                                                                            onChange={(e) => handleParkingUnit(e, index, 'agent_fee')}
                                                                            value={data.agent_fee}
                                                                            style={{width:'100%'}} 
                                                                            disabled={type === 'edit'}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                        
                                                    </div>
                                                ))
                                            }
                                        <Row>
                                            <Col span={12} className='mt-4'>
                                                <Button
                                                    type='primary'
                                                    className='button-color btn-header'
                                                    onClick={handleAddRow}
                                                    disabled={type === 'edit'}
                                                >
                                                    + Add Row
                                                </Button>
                                            </Col>  
                                            {
                                                parkingRow.length === 0 && (
                                                    <Col span={12} className='mt-4 tenants-terminated'>
                                                        *The Parking Details is Required
                                                    </Col> 
                                                )
                                            } 
                                        </Row>
                                    </>
                                )
                            }
                            <Divider className='divider-text mt-5'>Authorizations</Divider>
                            <Row>
                                <Col span={24} className='p-2'>
                                    Authorized Signatories
                                </Col>
                            </Row>
                            <Row className='responsive-overflow-y'>
                                <Col span={24} className='p-2'>
                                    <AddRowTable
                                        tableHeaders={[
                                            "Name",
                                            "Position",
                                        ]}
                                        headerSelector={[
                                            "signatory_name",
                                            "signatory_position",
                                        ]}
                                        withAction={true}
                                        withRender={false}
                                        withAddRow={true}
                                        isDisabled={isDisabled}
                                        setDataSource={setAuthorizedSignatories}
                                        dataSource={authorizedSignatories}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} className='p-2'>
                                    Local Authorized Representatives
                                </Col>
                            </Row>
                            <Row className='responsive-overflow-y'>
                                <Col span={24} className='p-2'>
                                
                                <AddRowTable
                                    tableHeaders={[
                                        "Name",
                                        "Position",
                                        "Email",
                                        "Mobile Number",
                                    ]}
                                    headerSelector={[
                                        "representative_name",
                                        "representative_position",
                                        "representative_email",
                                        "representative_contact_no",
                                    ]}
                                    withAction={true}
                                    withRender={false}
                                    withAddRow={true}
                                    isDisabled={isDisabled}
                                    setDataSource={setAuthorizedRepresentative}
                                    dataSource={authorizedRepresentative}
                                />
                            
                                </Col>
                            </Row>
                            <Row className='responsive-inline responsive-width'>
                                <Col span={24} className='p-2'>
                                    <Item
                                        label="Attachment"
                                        >
                                        <Item name="attachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                                            <Upload.Dragger name="files" action="/upload.do">
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                            </Upload.Dragger>
                                        </Item>
                                    </Item>
                                </Col>
                            </Row>
                            {
                                type === 'edit' && (
                                    <Row className=' mb-5'>
                                        <Col span={24} className=''>
                                            <Table 
                                                columns={columns2} 
                                                dataSource={newAttachment} 
                                                pagination={false}
                                                loading={{
                                                indicator: customSpinner,
                                                spinning: isLoading,
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                )
                            }
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate('/tenant')}
                                        className='cancel-color btn-header'
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={showSaveConfirm}
                                        loading={loading}
                                        type='primary'
                                        className='button-color btn-header'
                                        disabled={handleSaveValidation()}
                                    >
                                        {
                                            type === 'add' ? 
                                                'Submit' 
                                            : 
                                                'Save'
                                        }
                                    </Button>
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddEditTenants
